import CustomTag from 'components/CustomTag/CustomTag'
import AlaramIcon from 'components/icons/AlaramIcon'
import ConstructionIcon from 'components/icons/ConstructionIcon'
import FreeCancelationIcon from 'components/icons/FreeCancelationIcon'
import GroupPeopleIcon from 'components/icons/GroupPeopleIcon'
import LocationIcon from 'components/icons/LocationIcon'
import PaymentsIcon from 'components/icons/PaymentsIcon'
import moment from 'moment'
import React, { Fragment, useEffect, useRef, useState } from 'react'
import { formatNumber } from 'utils/formatNumber'

import Flex from 'components/Flex'
import FileIcon from 'components/icons/FileIcon'
import DownArrowIcon from 'components/icons/JobRoleIcons/DownArrowIcon'
import {
  AdjustIcon,
  StyledCardDiv,
  StyledDelete,
  StyledH2,
  StyledImg,
} from 'components/Uploader/Styles'
import { ButtonDiv } from 'modules/JobPreview/style'

import {
  ApplySpan,
  AvarageMarksDiv,
  BranchDiv,
  CriteriaDiv,
  CriteriaFlex,
  DescriptionP,
  DescriptionPointsUl,
  DurationSpan,
  EducationDetailsDiv,
  FlexWrap,
  FreeCancelFlex,
  FullTimeDiv,
  FullTimeSpan,
  GrayTextSmall,
  GroupFlex,
  GroupPepoleDiv,
  InterviewRoundsDiv,
  JobDescriptionDiv,
  JobLocationDiv,
  JobLocationUl,
  LocationFlex,
  LocationList,
  LocationSpan,
  PaymentsSpan,
  PeopleCountSpan,
  RemoteFriendlyDiv,
  RemoteLocationDiv,
  RemoteSpan,
  RoleDescription,
  RolesInfoFlex,
  RolesInformationDiv,
  RoundsDiv,
  SalaryDetailsFlex,
  SalaryDiv,
  SalaryInfoDiv,
  SalarySpan,
  SubtitleSmall,
  TestInfoLi,
  TestsDiv,
  TopSectionFlex,
  YearOfPassDiv,
  YearSpan,
} from 'modules/Roles/Partials/ViewIndividualRole/Components/Styles/Style'
import { toWords } from 'number-to-words'
import styled from 'styled-components'
import { AndDivision } from '../../../../../components/UIComponents/PreviewScreen/style'
import { Condition, SkillBox } from '../../../../JobPreview/style'
import {
  Container1,
  Content,
  ExtraPadding,
  ShowMoreText,
  SubBold,
} from '../Style/style'

// ✅ styled component
const EligibilityContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
`

const EligibilityCriteriaDisplay = ({ criteria }) => {
  if (!criteria || !criteria.length) return null

  const renderCriterion = item => {
    return (item.qualification || []).flatMap((qual, qualIndex, qualArr) => {
      const selectedQuals = item.selected?.[qual] || []
      if (selectedQuals.length === 0) return []

      const qualContent = selectedQuals[0]?.isAllDegree
        ? [<SkillBox key={`${qual}-all`}>Any {qual}</SkillBox>]
        : selectedQuals.flatMap((subitem, subIndex, subArr) => {
            const streams = subitem.streams || []
            const subitemContent =
              streams.length === 0
                ? [
                    <SkillBox key={`${subitem.shortForm}-${subIndex}`}>
                      {subitem.shortForm}
                    </SkillBox>,
                  ]
                : streams.flatMap((stream, streamIndex, streamArr) => {
                    const specialisations = stream.specialisations || []
                    const streamContent =
                      specialisations.length === 0
                        ? [
                            <SkillBox
                              key={`${stream.name}-${streamIndex}`}
                            >{`${subitem.shortForm} - ${stream.name}`}</SkillBox>,
                          ]
                        : specialisations.flatMap(
                            (spec, specIndex, specArr) => [
                              <SkillBox
                                key={`${spec.name}-${specIndex}`}
                              >{`${subitem.shortForm} - ${stream.name} - ${spec.name}`}</SkillBox>,
                              specIndex < specArr.length - 1 && (
                                <Condition
                                  key={`spec-or-${spec.name}-${specIndex}`}
                                >
                                  Or
                                </Condition>
                              ),
                            ]
                          )

                    return [
                      ...streamContent,
                      streamIndex < streamArr.length - 1 && (
                        <Condition
                          key={`stream-or-${stream.name}-${streamIndex}`}
                        >
                          Or
                        </Condition>
                      ),
                    ]
                  })

            return [
              ...subitemContent,
              subIndex < subArr.length - 1 && (
                <Condition key={`subitem-or-${subitem.shortForm}-${subIndex}`}>
                  Or
                </Condition>
              ),
            ]
          })

      return [
        ...qualContent,
        qualIndex < qualArr.length - 1 && (
          <Condition key={`qual-or-${qual}-${qualIndex}`}>Or</Condition>
        ),
      ]
    })
  }

  return (
    <EligibilityContainer>
      {(criteria || [])
        .flatMap((item, itemIndex, itemArr) => [
          ...renderCriterion(item),
          itemIndex < itemArr.length - 1 && (
            <AndDivision key={`and-${itemIndex}`}>And</AndDivision>
          ),
        ])
        .filter(Boolean)}
    </EligibilityContainer>
  )
}

const getRoundTypeText = text => {
  switch (text) {
    case 'EXTERNAL_ASSESMENT':
      return 'External Assessment'
    case 'ASSESMENT':
      return 'Assessment'
    case 'FACE_TO_FACE':
      return 'Interview'
    case 'GROUP':
      return 'Group Discussion'
    default:
      return text
  }
}

const JobDetails = ({ singleRoleDetails = {} }) => {
  const minCompensation = singleRoleDetails?.minCompensation
  const maxCompensation = singleRoleDetails?.maxCompensation
  const stipend = singleRoleDetails?.stipend
  let mandatorySkillNames = singleRoleDetails.jobRoleSkills ?? null

  const [showAll, setShowAll] = useState(false)
  const [showAllSkills, setShowAllSkills] = useState(false)
  const [expanded, setExpanded] = useState(true)
  const contentHeight = useRef(null)

  const toggleExpanded = () => setExpanded(!expanded)

  useEffect(() => {
    if (contentHeight?.current && contentHeight?.current?.clientHeight > 250) {
      setExpanded(false)
    }
  }, [])

  const downloadFileLocal = async file => {
    try {
      const fileUrl = file.fileUrl || file.fileURL || file.url
      const fileName = file.fileName || file.name

      if (!fileUrl) {
        console.error('No file URL found:', file);
        return;
      }

      const response = await fetch(fileUrl)
      if (!response.ok) 
        throw new Error('Network response was not ok')

      const blob = await response.blob()
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.download = fileName || 'download'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)
    } catch (error) {
      console.error('Download failed:', error)
    }
  }

  const numericToWords = number => {
    const words = toWords(number)
    return words.charAt(0).toUpperCase() + words.slice(1)
  }

  const toCamelCase = str => {
    const words = str?.split(' ')
    return words
      ?.map(word => word?.charAt(0)?.toUpperCase() + word?.slice(1)?.toLowerCase())
      ?.join(' ')
  }

  const checkJobTypeLevel = (data, YOE) => {
    const transformedData = data?.map(item => {
      switch (item) {
        case 'ENTRY':
          return ' Entry Level'
        case 'INTERN':
          return ' Internship'
        case 'EXPERIENCED':
          return ` ${YOE[0]} - ${YOE[1]} Yrs Experience `
        default:
          return item
      }
    })

    return transformedData?.toString()
  }

  return (
    <TopSectionFlex spaceBetween>
      <RolesInformationDiv>
        <RoleDescription>{singleRoleDetails?.tittle}</RoleDescription>

        <FullTimeDiv>
          <RolesInfoFlex>
            <GroupFlex centerVertically>
              <AlaramIcon />
              <FullTimeSpan>
                <SubtitleSmall marginbottom="0" capitalize={true}>
                  {checkJobTypeLevel(
                    singleRoleDetails?.jobTypeLevels,
                    singleRoleDetails?.yearOfExperience
                  )}
                  &nbsp;
                  {` (${singleRoleDetails?.jobType
                    ?.split('_')
                    ?.join(' ')
                    ?.toLowerCase()})`}
                </SubtitleSmall>
              </FullTimeSpan>
            </GroupFlex>

            <GroupPepoleDiv centerVertically>
              <GroupPeopleIcon />
              <PeopleCountSpan>
                {typeof singleRoleDetails?.minVacancies === 'object'
                  ? singleRoleDetails?.minVacancies?.value ||
                    singleRoleDetails?.minVacancies
                  : singleRoleDetails?.minVacancies}
                -
                {typeof singleRoleDetails?.maxVacancies === 'object'
                  ? singleRoleDetails?.maxVacancies?.value ||
                    singleRoleDetails?.maxVacancies
                  : singleRoleDetails?.maxVacancies}
              </PeopleCountSpan>
            </GroupPepoleDiv>

            <FreeCancelFlex centerVertically>
              <FreeCancelationIcon />
              <ApplySpan>Apply before</ApplySpan>
              <DurationSpan>
                {moment(singleRoleDetails?.endDate).format('DD/MM/YYYY')}
              </DurationSpan>
            </FreeCancelFlex>
          </RolesInfoFlex>
        </FullTimeDiv>

        <div>
          <JobDescriptionDiv>Job Description</JobDescriptionDiv>
          <DescriptionP
            dangerouslySetInnerHTML={{
              __html: singleRoleDetails?.description,
            }}
          />
        </div>

        {singleRoleDetails?.ctcType === 'FIXED_VARIABLE' && (
        <div>
          {(() => {
            const fixed = Number(singleRoleDetails?.minCompensation || 0);
            const variable = singleRoleDetails?.variableAmount;
            const hasVariable =
              variable !== null &&
              variable !== undefined &&
              `${variable}`.trim() !== '';

            if (singleRoleDetails?.ctcType === 'FIXED_VARIABLE' && hasVariable) {
              return (
                <div>
                  <JobDescriptionDiv mTop="10px" mBottom="5px">
                    Fixed+Variable
                  </JobDescriptionDiv>
                  <DescriptionP
                    style={{ marginTop: '1em', wordBreak: 'break-word' }}
                  >{variable}</DescriptionP>
                </div>
              );
            }
            return null;
          })()}
        </div>
      )}

        <div>
          {singleRoleDetails?.interviewWorkFlow?.rounds?.length > 0 && (
            <>
              <InterviewRoundsDiv>Evaluation Process</InterviewRoundsDiv>
              {singleRoleDetails?.interviewWorkFlow?.rounds?.map(
                (round, index) => (
                  <Fragment key={index + 'round'}>
                    <RoundsDiv>{round?.name}</RoundsDiv>
                    <TestsDiv>{getRoundTypeText(round?.type)}</TestsDiv>
                    <DescriptionPointsUl>
                      <TestInfoLi
                        dangerouslySetInnerHTML={{
                          __html: round?.description || '',
                        }}
                      />
                    </DescriptionPointsUl>
                  </Fragment>
                )
              )}
            </>
          )}
        </div>
        {/* Job Application / External Link */}
        {singleRoleDetails?.externalLink && (
          <div style={{ marginTop: '20px' }}>
            <InterviewRoundsDiv>Job Application Link</InterviewRoundsDiv>
            <a
              href={
                singleRoleDetails.externalLink.startsWith('http')
                  ? singleRoleDetails.externalLink
                  : `https://${singleRoleDetails.externalLink}`
              }
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: '#1635ffff',
                wordBreak: 'break-word',
                display: 'inline-block',
                margin: '5px 0 0 0',
                fontSize: '16px'
              }}
            >
              {singleRoleDetails.externalLink}
            </a>
          </div>
        )}
        {/* ✅ Updated Job Role Documents Section */}
        {(() => {
          const validJobRoleDocs = singleRoleDetails?.jobRoleDocs?.filter(item => {
            const fileName = item?.fileName || item?.name
            const fileUrl = item?.fileUrl || item?.fileURL || item?.url
            return item && fileName && fileUrl && fileName.trim() && fileUrl.trim()
          })

          if (!validJobRoleDocs?.length) return null

          return (
            <div style={{ marginTop: '20px' }}>
              <InterviewRoundsDiv>Attachments</InterviewRoundsDiv>
              <FlexWrap
                gap="10px"
                margintop="20px"
                width="77%"
                style={{
                  display: 'flex',
                  flexDirection:
                    validJobRoleDocs.length > 1 ? 'column' : 'row',
                }}
              >
                {validJobRoleDocs.map((item, key) => (
                  <StyledCardDiv key={`role-doc-${key}`}>
                    <StyledImg>
                      <AdjustIcon alignContent>
                        <FileIcon />
                      </AdjustIcon>
                      <Flex gap="5px">
                        <StyledH2>{item?.fileName}</StyledH2>
                        <StyledH2>{item?.fileSize}</StyledH2>
                      </Flex>
                    </StyledImg>
                    <Flex>
                      <StyledDelete>
                        <ButtonDiv>
                          <DownArrowIcon onClick={() => downloadFileLocal(item)} />
                        </ButtonDiv>
                      </StyledDelete>
                    </Flex>
                  </StyledCardDiv>
                ))}
              </FlexWrap>
            </div>
          )
        })()}
      </RolesInformationDiv>

      <SalaryInfoDiv>
        <SalaryDetailsFlex>
          <PaymentsSpan>
            <PaymentsIcon />
          </PaymentsSpan>
          <SalarySpan>{stipend === true ? 'No Stipend' : 'CTC'}</SalarySpan>
        </SalaryDetailsFlex>
{stipend !== true&& (
        <SalaryDiv>
          {minCompensation === maxCompensation ? (
            <span>
              ₹ {formatNumber(Number(minCompensation))}
              {` (${numericToWords(minCompensation)})`}
            </span>
          ) : (
            <span>
              ₹ {formatNumber(Number(minCompensation))}
              {`(${numericToWords(minCompensation)})`} - ₹{' '}
              {formatNumber(Number(maxCompensation))}
              {`(${numericToWords(maxCompensation)})`}
            </span>
          )}
        </SalaryDiv>
)}
        <LocationFlex>
          <LocationSpan>
            <LocationIcon />
          </LocationSpan>
          <JobLocationDiv>Job Location</JobLocationDiv>
        </LocationFlex>

        <JobLocationUl>
          {singleRoleDetails?.isAnyWhere ? (
            <LocationList>Any Where</LocationList>
          ) : singleRoleDetails?.cities?.length ? (
            singleRoleDetails?.cities?.map((location, index) => (
              <LocationList key={index + 'anyWhere'}>
                {location?.name ? location?.name : location?.state_name}
              </LocationList>
            ))
          ) : null}
        </JobLocationUl>

        {singleRoleDetails?.remotCities?.length ? (
          <>
            <RemoteFriendlyDiv>We are also remote friendly</RemoteFriendlyDiv>
            <RemoteLocationDiv>
              Remote Location:{' '}
              {singleRoleDetails?.remotCities?.map((remote, index) => (
                <RemoteSpan key={index + 'remote'}>
                  {remote?.name ?? remote?.state_name}
                </RemoteSpan>
              ))}
            </RemoteLocationDiv>
          </>
        ) : null}

        <CriteriaFlex>
          <ConstructionIcon />
          <CriteriaDiv>Eligibility Criteria</CriteriaDiv>
        </CriteriaFlex>

        <div>
          <GrayTextSmall>Gender</GrayTextSmall>
          <Content>{toCamelCase(singleRoleDetails?.publishTo)}</Content>
        </div>

        {mandatorySkillNames && mandatorySkillNames.length > 0 ? (
          <div>
            <GrayTextSmall>Skills</GrayTextSmall>
            <EligibilityContainer>
              <FlexWrap wrap gap="1px">
                {mandatorySkillNames.map(skill => (
                  <React.Fragment key={skill?.id}>
                    <CustomTag
                      message={skill.name}
                      marginright={'3px'}
                      background={'#F0F2F4'}
                    />
                  </React.Fragment>
                ))}
              </FlexWrap>
            </EligibilityContainer>
          </div>
        ) : null}

        <br />

        {singleRoleDetails?.eligibilityCriteria?.length && (
          <>
            <GrayTextSmall>Degree & Departments</GrayTextSmall>
            <EligibilityCriteriaDisplay
              criteria={singleRoleDetails?.eligibilityCriteria}
            />
          </>
        )}

        <YearOfPassDiv>Year of Passing</YearOfPassDiv>
        {singleRoleDetails?.yearOfPassing?.length > 0 && (
          <YearSpan>{singleRoleDetails?.yearOfPassing.join(', ')}</YearSpan>
        )}

        <YearOfPassDiv>Arrears / Backlogs</YearOfPassDiv>
        <BranchDiv>
          {!singleRoleDetails?.isArrearsAllowed
            ? 'No Arrears / Backlogs allowed.'
            : `Upto ${singleRoleDetails?.arrearCount} Arrears / Backlogs allowed.`}
        </BranchDiv>
      </SalaryInfoDiv>
    </TopSectionFlex>
  )
}

export default JobDetails